import { accessTokenItem, autologinTokenItem } from './auth-base.vm';
const getStorageItem = (key) => sessionStorage.getItem(key);
const setStorageItem = (key, value) => {
    sessionStorage.setItem(key, value);
};
const removeStorageItem = (key) => {
    sessionStorage.removeItem(key);
};
const removeLegacyLocalStorageItem = (key) => {
    localStorage.removeItem(key);
};
export const getAccessToken = () => getStorageItem(accessTokenItem);
export const getAutologinToken = () => getStorageItem(autologinTokenItem);
export const persistJwt = (data) => {
    const { accessToken, autologin = false } = data;
    if (accessToken)
        setStorageItem(accessTokenItem, accessToken);
    setStorageItem(autologinTokenItem, autologin ? 'true' : 'false');
};
export const cleanJwt = () => {
    removeStorageItem(accessTokenItem);
    removeStorageItem(autologinTokenItem);
    // Cleanup from previous versions that stored auth in localStorage
    removeLegacyLocalStorageItem(accessTokenItem);
    removeLegacyLocalStorageItem(autologinTokenItem);
};
export const promiseJwt = (promise) => new Promise((resolve, reject) => {
    promise()
        .then(res => {
        persistJwt(res.data);
        resolve(res);
    })
        .catch((e) => {
        console.error('promiseJwt', e);
        reject(e);
    });
});
